var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1h1BubYfUOs6MB{position:relative;line-height:10px}._1WhQFAwFP-LRW0:hover{background-color:#c1c7d0}._1WhQFAwFP-LRW0._1loDTzg0j8tGqh{position:relative}._1WhQFAwFP-LRW0._1loDTzg0j8tGqh:hover:before{opacity:.2}._1WhQFAwFP-LRW0._1loDTzg0j8tGqh:before{background-color:#c1c7d0;border-radius:50%;content:\"\";height:100%;left:0;opacity:0;position:absolute;top:0;width:100%}._2j3VanQfklIs53,.iJIz6ReoV0ykJj{background-size:100%;position:absolute;z-index:3;right:1px}.iJIz6ReoV0ykJj{height:7px;width:11px;top:1px;background-image:url(" + escape(require("resources/images/TrelloGoldBadge.png")) + ")}._2j3VanQfklIs53{height:9px;width:9px;bottom:0;background-image:url(" + escape(require("resources/images/chevron.png")) + ")}", ""]);

// exports
exports.locals = {
	"memberAvatar": "_1h1BubYfUOs6MB",
	"hoverable": "_1WhQFAwFP-LRW0",
	"withImage": "_1loDTzg0j8tGqh",
	"gold": "iJIz6ReoV0ykJj",
	"admin": "_2j3VanQfklIs53"
};